import { Icon, LinkCta, Stack, Text } from '@global-ecom/nitro-uds/elements';
import { useEffect } from 'react';

import { useTranslate } from 'hooks/useTranslations';
import { AnalyticsEvents, event } from 'utils/analytics';
import { useSiteConfig } from 'hooks/useSiteConfig';
import { usePopupsOpenStore } from 'store';

export const CartButtonPopup = ({
  popularityCount,
  productCount,
}: {
  popularityCount: number;
  productCount: number;
}) => {
  const t = useTranslate();
  const { staticFeatures } = useSiteConfig();

  const { isPopupOpen, setPopupOpen } = usePopupsOpenStore();

  // hide pop up after 5 seconds
  useEffect(() => {
    if (isPopupOpen('CartButtonPopup')) {
      setTimeout(() => {
        setPopupOpen('CartButtonPopup', false);
      }, 5 * 1000); // 5 seconds;
    }
  }, [isPopupOpen, setPopupOpen]);

  return (
    <Stack
      className={`sm:hidden fixed right-0 z-[1500] -bottom-px px-4 pt-6 pb-12 bg-success-90 transition-transform duration-300 ${
        isPopupOpen('CartButtonPopup') ? '-translate-y-0' : 'translate-y-full'
      }`}
      gapY="sm"
      data-test-id="added-to-cart-message"
    >
      <Stack
        direction="inline"
        items="center"
        justify="between"
        className="h-auto"
      >
        <Stack direction="row" items="center" gapX="xs">
          <Icon name="check-filled" size="base" invert="true" color="base" />
          <Text
            transform="uppercase"
            invert="true"
            size="xs"
            color="base"
            weight="bold"
          >
            {t('miniCartAddedToCart')}
          </Text>
        </Stack>
        <Icon
          name="close"
          size="lg"
          invert="true"
          color="base"
          onClick={() => setPopupOpen('CartButtonPopup', false)}
        />
      </Stack>
      <Stack>
        {staticFeatures.enablePopularity && popularityCount > 0 && (
          <Text invert="true" color="base" size="xs" transform="uppercase">
            {popularityCount} + {t('popularityMessage')}
          </Text>
        )}
      </Stack>
      <LinkCta
        label={t('miniCartViewCartAndCheckout', {
          count: productCount,
        })}
        href="/cart"
        key="cart"
        className="text-success-60 rounded-sm"
        variant="primary"
        invert="true"
        size="base"
        onClick={() => {
          event(AnalyticsEvents.MINICART, {
            domevent: 'button clicked',
            domlabel: 'cart page',
          });
          event(AnalyticsEvents.GA4_CustomEvent, {
            event_name: AnalyticsEvents.MINICART,
            event_params: {
              user_action: 'view cart/checkout',
            },
          });
        }}
      />
    </Stack>
  );
};
